import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <header className="privacy-header">
          <Link className="privacy-back" to="/">
            <span aria-hidden="true">&larr;</span>
            Voltar para a landing
          </Link>
          <h1 className="privacy-title">POLÍTICA DE PRIVACIDADE — FOODSTATION</h1>
          <p className="privacy-updated">Última atualização: 05/01/2025</p>
        </header>

        <main className="privacy-card">
          <section className="privacy-section">
            <h2>1. Introdução</h2>
            <p>
              A FoodStation, plataforma pertencente ao Grupo Gourmex e operada pela GOURMEX
              TECNOLOGIA E MARKETING LTDA, respeita a privacidade e a proteção dos dados pessoais,
              tratando-os conforme a Lei Geral de Proteção de Dados (Lei nº 13.709/2018).
            </p>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>2. Agente de Tratamento</h2>
            <p>
              A GOURMEX atua como Controladora ou Operadora de Dados, conforme a natureza do
              tratamento realizado.
            </p>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>3. Dados Coletados</h2>
            <ul className="privacy-list">
              <li>3.1. Dados cadastrais do Usuário.</li>
              <li>3.2. Dados operacionais inseridos na Plataforma.</li>
              <li>3.3. Dados de navegação e logs de acesso.</li>
              <li>3.4. Dados de clientes finais inseridos pelo restaurante.</li>
            </ul>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>4. Finalidade do Tratamento</h2>
            <p>Os dados são tratados para:</p>
            <ul className="privacy-list">
              <li>a) Prestação dos serviços;</li>
              <li>b) Suporte e comunicação;</li>
              <li>c) Segurança e prevenção de fraudes;</li>
              <li>d) Cumprimento de obrigações legais;</li>
              <li>e) Melhoria contínua da Plataforma.</li>
            </ul>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>5. Inteligência Artificial</h2>
            <ul className="privacy-list">
              <li>5.1. Dados não são utilizados para treinar modelos de IA de terceiros.</li>
              <li>5.2. A IA atua como ferramenta auxiliar.</li>
              <li>5.3. O Usuário é responsável por validar conteúdos e decisões.</li>
            </ul>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>6. Compartilhamento de Dados</h2>
            <p>Os dados podem ser compartilhados apenas com prestadores essenciais, como:</p>
            <ul className="privacy-list">
              <li>a) Infraestrutura em nuvem;</li>
              <li>b) Processadores de pagamento;</li>
              <li>c) Serviços de suporte e monitoramento.</li>
            </ul>
            <p>A GOURMEX não vende dados pessoais.</p>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>7. Segurança da Informação</h2>
            <p>
              Adotamos medidas técnicas e organizacionais adequadas para proteção dos dados,
              incluindo controle de acesso, criptografia e monitoramento.
            </p>
            <p>Nenhum sistema é totalmente imune a riscos.</p>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>8. Retenção e Exclusão</h2>
            <p>Os dados são mantidos:</p>
            <ul className="privacy-list">
              <li>a) Durante a vigência da conta;</li>
              <li>b) Pelo prazo legal necessário após o cancelamento.</li>
            </ul>
            <p>Após esse período, os dados são eliminados ou anonimizados.</p>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>9. Direitos do Titular</h2>
            <p>O titular pode solicitar:</p>
            <ul className="privacy-list">
              <li>a) Acesso;</li>
              <li>b) Correção;</li>
              <li>c) Exclusão;</li>
              <li>d) Portabilidade;</li>
              <li>e) Revogação de consentimento.</li>
            </ul>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>10. Canais de Contato</h2>
            <div className="privacy-contact">
              <p>GOURMEX TECNOLOGIA E MARKETING LTDA</p>
              <p>CNPJ: 51.555.314/0001-91</p>
              <p>
                Endereço: Rua Dra. Rita Lobato, 194, Apto 202, Andar 2, Praia de Belas, Porto
                Alegre/RS, CEP 90110-040
              </p>
              <p>E-mail de suporte: contato@foodstation.com.br</p>
            </div>
          </section>

          <hr className="privacy-divider" />

          <section className="privacy-section">
            <h2>11. Alterações Desta Política</h2>
            <p>
              Esta Política poderá ser atualizada a qualquer tempo. O uso contínuo da Plataforma
              implica concordância com a versão vigente.
            </p>
          </section>
        </main>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
